export default __webpack_public_path__ + "static/media/GC.26971406.png";